'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n      &::before {\n        margin-right: ', ';\n      }\n    '], ['\n      &::before {\n        margin-right: ', ';\n      }\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n  align-items: center;\n  color: ', ';\n  display: flex;\n  text-transform: inherit;\n'], ['\n  align-items: center;\n  color: ', ';\n  display: flex;\n  text-transform: inherit;\n']);

var _styledComponents = require('styled-components');

var _decisivUiUtils = require('decisiv-ui-utils');

var _elements = require('../../elements');

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var modifierConfig = {
  withContent: function withContent() {
    return {
      styles: (0, _styledComponents.css)(_templateObject, (0, _decisivUiUtils.px2rem)(5))
    };
  }
};

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return (0, _styledComponents.css)(_templateObject2, theme.colors.base.textLight);
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Checkbox__Label', _elements.Label, styles, {
  modifierConfig: modifierConfig
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Checkbox/Label.js
// module id = 1559
// module chunks = 2